import { DotsHorizontalIcon } from '@radix-ui/react-icons';
import { VariantProps } from 'class-variance-authority';
import { HTMLAttributes, type JSX } from 'react';

import { Button, buttonVariants } from '../../primitives/button';
import { DropdownMenuTrigger } from '../../primitives/dropdown-menu';

interface DropdownMenuTriggerIconProps
  extends
    VariantProps<typeof buttonVariants>,
    Pick<HTMLAttributes<HTMLDivElement>, 'className' | 'id'> {
  disabled?: boolean;
  icon?: JSX.Element;
}

export function DropdownMenuTriggerIcon({
  className,
  disabled = false,
  icon = <DotsHorizontalIcon className="size-4" />,
  id,
  size = 'icon',
  variant = 'outline',
}: DropdownMenuTriggerIconProps) {
  return (
    <DropdownMenuTrigger asChild disabled={disabled} className="flex-none">
      <Button id={id} className={className} size={size} variant={variant}>
        <span className="sr-only">Abrir opciones</span>
        {icon}
      </Button>
    </DropdownMenuTrigger>
  );
}
